var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('button',{staticClass:"orangebtn tw-text-white tw-font-medium tw-py-3 tw-rounded tw-tracking-wide tw-px-3",on:{"click":_vm.greet}},[_c('img',{attrs:{"src":"/img/plus.svg"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }